import { useEffect, useState } from 'react';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/stores/auth';
import { PAYMENTS_ENABLED } from '@makhe/shared';

const STORAGE_KEY = 'makhe.tour.seen.v1';

const STEPS = [
  {
    n: '01',
    title: 'Welcome to Makhe',
    body: PAYMENTS_ENABLED
      ? 'Verified students. Real videos. Pay in the app. Money moves when you confirm the service was done.'
      : 'Verified students. Real videos. Find a creator, book a time, and pay them directly.',
  },
  {
    n: '02',
    title: 'Scroll the feed',
    body: 'Tap to unmute. Heart a creator to save them. Hit the price chip to see tiers and book.',
  },
  PAYMENTS_ENABLED
    ? {
        n: '03',
        title: 'Payment is held',
        body: 'You pay up front. We hold the money. Confirm the service is done and the seller gets paid.',
      }
    : {
        n: '03',
        title: 'Booking and payment',
        body: 'Agree the price when you book. Nothing changes at the door. You pay your creator directly.',
      },
  {
    n: '04',
    title: 'Become a creator',
    body: 'Have a service to offer? Open Profile, then Become a creator. Setup takes about three minutes.',
  },
];

export function FirstRunTour() {
  const { firebaseUser, userDoc } = useAuth();
  const [step, setStep] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!firebaseUser || !userDoc) return;
    if (userDoc.studentVerification?.status !== 'verified') return;
    if (localStorage.getItem(STORAGE_KEY)) return;
    setOpen(true);
  }, [firebaseUser, userDoc]);

  const close = () => {
    localStorage.setItem(STORAGE_KEY, 'yes');
    setOpen(false);
  };

  const current = STEPS[step]!;
  const isLast = step === STEPS.length - 1;

  return (
    <Modal open={open} onClose={close}>
      <p className="eyebrow">Step {current.n} · of 04</p>
      <h2
        className="mt-4 font-display text-3xl leading-tight"
        style={{ fontVariationSettings: '"opsz" 72, "wght" 400' }}
      >
        {current.title}
      </h2>
      <p className="mt-3 text-[15px] leading-relaxed text-makhe-ink/80">{current.body}</p>
      <div className="mt-7 flex items-center justify-between">
        <div className="flex gap-1.5">
          {STEPS.map((_, i) => (
            <span
              key={i}
              className={`h-1 w-8 rounded-full transition-colors ${
                i === step ? 'bg-makhe-ink' : 'bg-makhe-line'
              }`}
            />
          ))}
        </div>
        <Button variant="ink" onClick={() => (isLast ? close() : setStep(step + 1))}>
          {isLast ? 'Begin →' : 'Next'}
        </Button>
      </div>
    </Modal>
  );
}
